/*
 * DisplayTweaks - changes to html that is used in multiple places
 */

export default class DisplayTweaks {
    constructor() {
        // wrap last word in text and any html elements in span.dontwrap
        $('.js-wrap-advice-title').each((i, item) => {
            const $item = $(item);
            const $children = $item.children();
            const text = $item.text();
            const parts = text.trim().split(' ');
            if (!parts.length) return; // one or no words in text

            // create span with last word, add html
            const $new = $(`<span class="dontwrap">${parts[parts.length - 1]}</span>`);
            $new.append($children);

            // replace old contents with new span
            $item.html($new);
            parts.pop();
            // add start of string to contents
            $item.prepend(document.createTextNode(`${parts.join(' ')} `));
        });
    }
}
